import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

// Add scroll event listener for header resize
const handleScroll = () => {
  const header = document.querySelector('.header')
  if (window.scrollY > 50) {
    header.classList.add('scrolled')
  } else {
    header.classList.remove('scrolled')
  }
}

// Add scroll event listener when the component mounts
const root = ReactDOM.createRoot(document.getElementById('root'))

// Initial render
root.render(
  <React.StrictMode>
    <App onMount={() => {
      // Add scroll event listener after the app is mounted
      window.addEventListener('scroll', handleScroll)
      // Initial check in case the page is loaded with scroll position
      handleScroll()
    }} />
  </React.StrictMode>
)

// Clean up event listener when the component unmounts
const cleanup = () => {
  window.removeEventListener('scroll', handleScroll)
}

// Export cleanup function for potential use in the future
export { cleanup }

